"use strict";

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("babel-polyfill");

var environment = {
  development: {
    env: "development",
    isProduction: false,
    home: "http://localhost",
    // apiHost: 'http://localhost',
    // apiPort: 3030,
    apiHost: "https://maaporssi-api-staging.herokuapp.com",
    // apiHost: "https://maaporssi-api.herokuapp.com",
    apiPort: 443,
    googleMapsApiKey: "AIzaSyD2xQfYHADv_xCSQyCfYzmvW72UzB7-Vi0",
    googleTagManagerCode: "GTM-TVZWPD8"
  },
  staging: {
    env: "staging",
    isProduction: true,
    home: "https://testi.maaporssi.fi",
    apiHost: "https://maaporssi-api-staging.herokuapp.com",
    apiPort: 443,
    googleMapsApiKey: "AIzaSyD2xQfYHADv_xCSQyCfYzmvW72UzB7-Vi0",
    googleTagManagerCode: "GTM-TV9FJZC"
  },
  production: {
    env: "production",
    isProduction: true,
    home: "https://www.maaporssi.fi",
    apiHost: "https://maaporssi-api.herokuapp.com",
    apiPort: 443,
    googleMapsApiKey: "AIzaSyD2xQfYHADv_xCSQyCfYzmvW72UzB7-Vi0",
    googleTagManagerCode: "	GTM-MGRW9L"
  }
}[process.env.CONFIG_ENV || "development"];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || "localhost",
  port: process.env.PORT,
  tokenCookie: "accessToken",
  app: {
    title: "Maapörssi",
    description: "Maapörssi on maa-ainesten kierrätyspörssi. Palvelun avulla voit tehokkaasti kierrättää työmaalta tulevat ylijäämä maa-ainekset ja voit hankkia tarvitsemiasi maa-aineksia.",
    head: {
      titleTemplate: "Maapörssi - %s",
      meta: [{
        name: "description",
        content: "Maapörssi on maa-ainesten kierrätyspörssi. Palvelun avulla voit tehokkaasti kierrättää työmaalta tulevat ylijäämä maa-ainekset ja voit hankkia tarvitsemiasi maa-aineksia."
      }, { property: "og:title", content: "Maapörssi" }, {
        property: "og:description",
        content: "Maapörssi on maa-ainesten kierrätyspörssi. Palvelun avulla voit tehokkaasti kierrättää työmaalta tulevat ylijäämä maa-ainekset ja voit hankkia tarvitsemiasi maa-aineksia."
      }, {
        property: "og:image",
        content: environment.home + "/img/maaporssi-preview.png"
      }, { property: "twitter:title", content: "Maapörssi" }, {
        property: "twitter:description",
        content: "Maapörssi on maa-ainesten kierrätyspörssi. Palvelun avulla voit tehokkaasti kierrättää työmaalta tulevat ylijäämä maa-ainekset ja voit hankkia tarvitsemiasi maa-aineksia."
      }, {
        property: "twitter:image",
        content: environment.home + "/img/maaporssi-preview.png"
      }, { name: "msapplication-TileColor", content: "#ffffff" }, {
        name: "msapplication-TileImage",
        content: environment.home + "/icons/ms-icon-144x144.png"
      }, { name: "theme-color", content: "#ffffff" }, { charset: "utf-8" }],
      link: [{
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: "/icons/apple-icon-57x57.png"
      }, {
        rel: "apple-touch-icon",
        sizes: "60x60",
        href: "/icons/apple-icon-60x60.png"
      }, {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: "/icons/apple-icon-72x72.png"
      }, {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: "/icons/apple-icon-76x76.png"
      }, {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: "/icons/apple-icon-114x114.png"
      }, {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: "/icons/apple-icon-120x120.png"
      }, {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: "/icons/apple-icon-144x144.png"
      }, {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: "/icons/apple-icon-152x152.png"
      }, {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: "/icons/apple-icon-180x180.png"
      }, {
        rel: "icon",
        type: "image/png",
        sizes: "192x192",
        href: "/icons/android-icon-192x192.png"
      }, {
        rel: "icon",
        type: "image/png",
        sizes: "96x96",
        href: "/icons/favicon-96x96.png"
      }, {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: "/icons/32x32.png"
      }, {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: "/icons/favicon-16x16.png"
      }, { rel: "icon", href: "/favicon.ico" }, { rel: "manifest", href: "/icons/manifest.json" }]
    }
  }
}, environment);


/*****************
 ** WEBPACK FOOTER
 ** ./src/config.js
 ** module id = 135
 ** module chunks = 0
 **/